import { useEffect, useState } from "preact/hooks";

/**
 * Tracks a markup-modal host's `open` attribute.
 *
 * Not the `markup-modal:closed` event — it carries no id, so it fires for every
 * host on the page and can't say which one closed.
 *
 * @param {string} modalId
 * @returns {boolean}
 */
export default function useModalOpenState(modalId) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const host = document.getElementById(modalId);

    if (!host) return;

    const read = () => setOpen(host.hasAttribute("open"));

    read();

    const observer = new MutationObserver(read);

    observer.observe(host, { attributes: true, attributeFilter: ["open"] });

    return () => observer.disconnect();
  }, [modalId]);

  return open;
}
